export class ThematicDto {
  thematicId?: number;
  titleFrancais: string;
  titleAnglais: string;
  pathImage: string;
  urlImage: string;
}
